import { module } from 'modujs';
import { lazyLoadImage } from '../utils/image';

const REWARD_LAUNCHER_URL = "#smile-home"
export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                'sublist-toggler': 'onClick',
            },
            mouseenter: {
                'sublist-toggler': 'onMouseEnter',
                'sublist': 'onMouseEnter'
            },
            mouseleave: {
                'sublist-toggler': 'onMouseLeave',
                'sublist': 'onMouseLeave'
            }
        }
    }

    init() {
        this.$sublists = this.$('sublist')
        this.$sublistTogglers = this.$('sublist-toggler')
        this.$rewardsButtons = this.el.querySelectorAll("[href='" + REWARD_LAUNCHER_URL + "']");

        this.bindEvents()
    }

    bindEvents() {
        this.onRewardsClickBind = this.onRewardsClick.bind(this)
        if (this.$rewardsButtons.length) {
            this.$rewardsButtons.forEach($rewardButton => {
                $rewardButton.addEventListener('click', this.onRewardsClickBind)
            })
        }
    }

    unbindEvents() {
        if (this.$rewardsButtons.length) {
            this.$rewardsButtons.forEach($rewardButton => {
                $rewardButton.removeEventListener('click', this.onRewardsClickBind)
            })
        }
    }

    onClick(e) {
        this.toggle(e)
    }

    onMouseEnter(e) {
        const id = e.curTarget.dataset.id

        this.clearItemsState()

        this.$sublists.forEach((item) => {
            if(item.dataset.id == id) {
                let images = item.querySelectorAll('[data-lazy]')
                images ??= false

                if(images) {
                    images.forEach((item) => {
                        lazyLoadImage(item)
                    })
                }

                item.classList.add('is-active')
            }
        })

        this.$sublistTogglers.forEach((item) => {
            if(item.dataset.id == id) item.classList.add('is-active')
        })

        // Close search bar
        this.call('close', null, 'Search')
    }

    onMouseLeave(e) {
        this.clearItemsState()
    }

    onRewardsClick() {
        this.call('close', null, 'Menu')
    }

    toggle(e) {
        let item = e.curTarget

        if (item.classList.contains('is-active')) {
            this.onMouseLeave(e)
        } else {
            this.onMouseLeave(e)
            this.onMouseEnter(e)
        }
    }

    clearItemsState() {
        this.$sublists.forEach((item) => {
            item.classList.remove('is-active')
        })
        this.$sublistTogglers.forEach((item) => {
            item.classList.remove('is-active')
        })
    }

    destroy() {
        super.destroy()

        this.unbindEvents()
    }
}
